import { useNavigate } from 'react-router';
import { ClientsMarquee } from '../ClientsMarquee';
import { IoIosArrowDown } from "react-icons/io";
import bindinntechs from '../../../../Assets/bindinntechs_logo.png'
import bindtrack from '../../../../Assets/bindtrack_logo.png'
import fisioteraplay from '../../../../Assets/fisioteraplay_logo.png'
import atendivet from '../../../../Assets/atendivet_logo.png'
import whatsign from '../../../../Assets/whatsign_logo.png'





import * as S from './styles'

const logos = [
  {
    src: bindinntechs,
    alt: "bindinntechs"
  },
  {
    src: bindtrack,
    alt: "bindtrack"
  },
  {
    src: fisioteraplay,
    alt: "fisioteraplay"
  },
  {
    src: atendivet,
    alt: "atendivet"
  },
  {
    src: whatsign,
    alt: "whatsign"
  },
  {
    src: bindinntechs,
    alt: "bindinntechs"
  },
  {
    src: bindtrack,
    alt: "bindtrack"
  },
  {
    src: fisioteraplay,
    alt: "fisioteraplay"
  },
  {
    src: atendivet,
    alt: "atendivet"
  },
  {
    src: whatsign,
    alt: "whatsign"
  },
];

export const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <S.BgBox>

      <S.Wrapper>
        <div className='bg circuitLeft'></div>
        <div className='bg logo'>
          <div className='orbit'>
            <div className='colors blue'></div>
            <div className='colors pink'></div>
          </div>
        </div>
        <div className='bg circuitright'></div>
        <h1>
          Ideias ganham vida.<br />Negócios ganham futuro.
        </h1>

        <p>
          Conectamos sua visão à tecnologia. <br className='brFirst' />Combinamos estratégia, dados e inovação para transformar <br className='brSecond' />ideias em resultados palpáveis
        </p>

        <S.ActionBtn
          onClick={() => navigate("/contato")}
        >
          Fale com nosso time
        </S.ActionBtn>

      </S.Wrapper>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <ClientsMarquee
          items={logos}
          height={36}
          gap={84}
          duration={26}
          padY={28}
          glowColor="rgba(76,137,255,.50)"
          shadowHeight={64}
          direction="rtl"
        />
      </div>

      <S.nextBtn>
        <IoIosArrowDown size={12} />
        <IoIosArrowDown size={24} />
      </S.nextBtn>
    </S.BgBox>
  )
}
